var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn white --sm",attrs:{"href":"https://www.eyemed.com","target":"_blank"}},[_vm._v("visit eyemed.com")])])}]

export { render, staticRenderFns }